import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((c) => (
        <a
          key={c.id}
          href={c.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-0.5 hover:border-primary-300"
        >
          <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md">
            <img
              src={c.image}
              alt={t(`cat.${c.id}`)}
              title={`${t(`cat.${c.id}`)} USFans`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600">
              {t(`cat.${c.id}`)}
            </p>
            <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
              {t('categories.view')}
              <i className="ri-arrow-right-up-line w-3 h-3 flex items-center justify-center"></i>
            </p>
          </div>
        </a>
      ))}
    </div>
  );
}